import { connect } from 'react-redux';
import MeetingRegisteryRow from './MeetingRegisteryRow';
import { sortRegisteryRequest } from '../../../../../store/actions/meetings.actions';

const mapDispatchToProps = { sortRegisteryRequest };

export default connect(null, mapDispatchToProps)(MeetingRegisteryRow);